/*
 * This file is part of glowingblue/orell-articles.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import ArticlesPage from './components/ArticlesPage';

export default function addArticlesPage(): void {
	app.routes.of_articles = { path: '/articles', component: ArticlesPage };
	app.route.of_articles = (q?: string) => app.route('of_articles', { q });
}
